export enum Salutation {
    MR = 'MR',
    MRS = 'MRS',
    MX = 'MX'
}
